<template>
  <!-- 사진촬영 허가 신청 안내 -->
  <v-card class="ma-4 word_keeper">
    <v-toolbar dense flat color="white">
      <v-toolbar-title class="font-weight-bold" style="min-width:140px;">
        <v-icon class="mr-2">mdi-monitor-eye</v-icon>사진촬영 허가 신청 안내
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="mr-4 ml-4"></v-divider>
    <v-toolbar dense flat color="white">
      <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
        사진촬영 허가 신청 및 반출절차는 이렇게 하세요.
      </v-card-subtitle>
    </v-toolbar>
    <v-card-subtitle class="pt-2 pb-2 text-caption grey--text text-justify text--darken-2 font-weight-bold">
      <div class="mb-1 d-flex">1.&nbsp;<div>허가서에 기재된 허가내용 범위 내(장소, 목적 등)에서만 촬영해야 합니다.</div></div>
      <div class="mb-1 d-flex">2.&nbsp;<div>SK 스페셜티의 경영정보가 무단 촬영되지 않도록 주의 바랍니다.</div></div>
      <div class="mb-1 d-flex">3.&nbsp;<div>블루투스 등 네트워크 연결 기능이 있는 촬영기기와 휴대전화은 신청이 불가합니다.</div></div>
      <div class="mb-1 d-flex">4.&nbsp;<div>언론사의 촬영은 홍보 주관부서와 사전 협조 후 신청하시기 바랍니다.</div></div>
      <div class="mb-1 d-flex">5.&nbsp;<div>촬영기기를 반출하는 경우 반드시 당사 구성원의 검사를 받으시기 바랍니다.</div></div>
      <div class="d-flex">6.&nbsp;<div>촬영장소는 SK 스페셜티 구성원의 근무 캠퍼스 내에서만 가능합니다.</div></div>
    </v-card-subtitle>
    <v-divider class="mr-4 ml-4"></v-divider>


    <div class="flex-wrap d-flex justify-center mt-10 mb-4">     
      <img src="../assets/SKST/Guide/guide_4_1.svg" style="height:200px; border-radius: 10px;"/>
      <img src="../assets/SKST/Guide/guide_4_2.svg" style="height:200px; border-radius: 10px;"/>
      <img src="../assets/SKST/Guide/guide_4_3.svg" style="height:200px; border-radius: 10px;"/>
      <img src="../assets/SKST/Guide/guide_4_4.svg" style="height:200px; border-radius: 10px;"/>                
      <img src="../assets/SKST/Guide/guide_4_5.svg" style="height:200px; border-radius: 10px;"/>
    </div>


    <v-card-text align="center">
      <v-divider class="mb-4"></v-divider>
      <v-btn @click="$router.push({name: 'MainBoard'});" width="100px" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
      <v-btn @click="$router.push({name: 'PictureReq'});" width="100px" dark class="ml-2"><v-icon class="mr-2">mdi-open-in-new</v-icon>신청</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
  }),
  computed: {  
  },
  created() {
  },
  mounted() {
  },

  methods : {
  }
}
</script>